import SocialProfileForm, { SocialProfileStateProps, SocialProfileFormOwnProps } from 'components/features/socialFeed/SocialProfileForm/SocialProfileForm'
import { State } from 'interfaces/state'
import { connectOptionally, OptionalRendererProps, createOptionalRenderer } from 'tangle-shared'
import { memberFeedInfoSelector } from 'selectors/feedSelectors'
import { submitFormActionCreator } from 'actions/formActions'
import { StoreDispatch } from 'interfaces/component'
import { FORM_SOCIAL_PROFILE } from 'constants/forms'
import { SocialProfileFormValues } from 'interfaces/feed'

const optionalRenderer = createOptionalRenderer<SocialProfileStateProps>()
const mapStateToProps = (state: State): OptionalRendererProps<SocialProfileStateProps> => {
  const memberFeed = memberFeedInfoSelector(state)
  if (!memberFeed) {
    return optionalRenderer.fallback()
  }

  const { uid, username, avatarId } = memberFeed

  return optionalRenderer.render({
    initialValues: {
      username,
      ...avatarId ? { avatar: avatarId } : {},
    },
    onSubmit: (values: SocialProfileFormValues, dispatch: StoreDispatch) => {
      dispatch(submitFormActionCreator(FORM_SOCIAL_PROFILE, values, { uid }))

      return {}
    },
  })
}

const SocialProfileFormContainer = connectOptionally<
  SocialProfileStateProps, {}, SocialProfileFormOwnProps
>(mapStateToProps, () => ({}))(SocialProfileForm)

export default SocialProfileFormContainer
